import { useContext, useRef } from 'react';

import { ApplicationContext } from '@App/contexts/Application';
import { QuestionsPageView } from '@Views/eligibility/loan-preferences/questions-page-view/QuestionsPageView';
import { OfferContext } from '@src/app/contexts/Offer';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';

export const LoanPreferencesQuestionsPage = () => {
    const { loading } = useContext(ApplicationContext);

    const { loading: debtConLoading } = useContext(OfferContext);

    const saveRef = useRef(null);

    return (
        <EligibilityLayout loading={loading || debtConLoading} ref={saveRef}>
            <QuestionsPageView />
        </EligibilityLayout>
    );
};
